import useLabels from "../../hooks/useLabels";
import bio from "../../assets/icons/bio.png";
import vegan from "../../assets/icons/vegan.png";
import "./styles/index.scss";

const LotLabelTag = ({ tag, tagKey, color, isIcon, isCell = false, isDetail = false, isMobile = false, onTagClick = null, isSelected = false }) => {

  const isCertification = ['Bio', 'Biodynamic', 'Vegan'].includes(tagKey);
  const isClickable = !isCertification && onTagClick;

  const getColor = () => {
    if (tag === 'Bio') return "light_green";
    if (tag === 'Biodynamic') return "light_green";
    if (tag === 'Vegan') return "green";
    else return color;
  }

  const handleClick = () => {
    if (isClickable && onTagClick) {
      onTagClick(tagKey);
    }
  };

  return (<div className="tag_wrapper">
    <div className={`tag ${getColor()} ${isCell ? "is_cell" : ""} ${isCertification ? "certification" : ""} ${isClickable ? "clickable" : ""} ${isSelected ? "selected" : ""}`} onClick={handleClick}>{tag}
      {tag ==='Bio' && isIcon && <img className="icon" src={bio} alt={'bio'} />}
      {tag === 'Vegan' && isIcon && <img className="icon" src={vegan} alt={'vegan'} />}
      {tag === 'Biodynamic' && isIcon && <img className="icon" src={bio} alt={'biodynamic'} />}
    </div>
  </div>)
}

const LotLabelTags = ({ tags = [], color = 'red', isIcon = false, isTitle = false, isDetail = false, isCell = false, isMobile = false, onTagClick = null, selectedTag = null }) => {
  const [getLabel] = useLabels();

  return (<div>
    {isTitle && isDetail && <h4>{getLabel("lotLabel")}</h4>}
    {isTitle && !isDetail && <h5 className="fix-margin">{getLabel("lotLabel")}</h5>}
    <div className="tags_wrapper">
    {tags?.map((tag, index) => {
        return (
          <LotLabelTag
            key={`label-${index}`}
            tag={getLabel(`lotLabel_${tag}`)}
            tagKey={tag}
            color={color}
            isIcon={isIcon}
            isCell={isCell}
            onTagClick={onTagClick}
            isSelected={selectedTag === tag}
          />
        );
      }, "") || ""}
    </div>
  </div>)
}

export default LotLabelTags;
